import type { TApiResponse, TApiResponseType } from '@/types/api-types/TApiResponse'
import type {
  IAccountApi,
  TAccountAccessRequestBody,
  TAccountAccessRenewBody,
  TAccountAccessRevokeBody,
  TAccountResetPasswordBody,
  TAccountConfirmNewPasswordBody
} from '@/types/api-types/account'
import type { ICollectionResponseType } from '@/types/api-types/IApiResponse'
import AccountApiUrls from './endpoints'
import BaseApiRequest from '../BaseApiRequest'
import EmployeeApiUrls from '../employees/endpoints'

class AccountApiRequest extends BaseApiRequest implements IAccountApi {
  async requestAccess(user: TAccountAccessRequestBody): TApiResponse {
    return this.authProvider.requestAuth(AccountApiUrls.REQUEST(), user)
  }

  async renewAccess(user: TAccountAccessRenewBody): TApiResponse {
    return this.authProvider.renewAuth(user)
  }

  async revokeAccess(user: TAccountAccessRevokeBody): TApiResponse {
    return this.authProvider.revokeAuth(AccountApiUrls.LOGOUT(), user)
  }

  async getRole(): TApiResponse {
    return this.get(AccountApiUrls.ROLE())
  }

  async getProfile(id: string): TApiResponse {
    return this.get(EmployeeApiUrls.EMPLOYEES_BY_ID(id))
  }

  async getPermissions(): TApiResponseType<ICollectionResponseType> {
    return this.get(AccountApiUrls.PERMISSIONS())
  }

  async resetPassword(requestBody: TAccountResetPasswordBody): TApiResponse {
    return this.post(AccountApiUrls.RESET_PASSWORD(), requestBody)
  }

  async confirmNewPassword(requestBody: TAccountConfirmNewPasswordBody): TApiResponse {
    return this.post(AccountApiUrls.CONFIRM_NEW_PASSWORD(), requestBody)
  }
}

export default AccountApiRequest
